export enum ImageType {
	ACCESSORY = 'accessory',
	INGREDIENT = 'ingredient',
	RECIPE = 'recipe',
}
